<template>
  <div class="main" :style="{'minHeight': mainHeight}">
    <img class="step" src="../../static/img/password-head.png"/>
    <el-form class="form" ref="form" :rules="dataRule" :model="formData">
      <h4>Provide the email address you used to register below. You will receive an email with a link allowing you to update your password to something you remember.</h4>
      <el-form-item prop="password">
        <el-input class="customInp-small" v-model="formData.password" placeholder="New password" show-password></el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input class="customInp-small" v-model="formData.confirmPassword" placeholder="Enter again" show-password></el-input>
      </el-form-item>
      <div class="next_btn" @click="handleNext">NEXT</div>
    </el-form>
  </div>
</template>

<script>
import { getQueryVariable } from '@/utils/index'
export default {
  name: 'modifyPassword',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter confirm password'))
      } else if (value !== this.formData.password) {
        callback(new Error('The two passwords are inconsistent'))
      } else {
        callback()
      }
    }
    return {
      mainHeight: 0,
      formData: {
        password: '',
        confirmPassword: ''
      },
      dataRule: {
        password: [
          { required: true, message: 'Please enter password', trigger: 'blur' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, message: 'The length shall be at least 8 and contain at least one letter and one number', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, message: 'The length shall be at least 8 and contain at least one letter and one number', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => this.setWindowHeight())
    if (getQueryVariable(location.href, 'token')) {
      this.$cookie.set('sw_token', getQueryVariable(location.href, 'token'))
    }
  },
  methods: {
    setWindowHeight () {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    },

    handleNext () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('/sys/user/reset/pass'),
            method: 'put',
            data: this.formData.password
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$http({
                url: this.$http.adornUrl('/sys/logout'),
                method: 'post',
                data: this.$http.adornData()
              }).then(({data}) => {
                if (data && data.code === 0) {
                  this.$message.success('Modify successfully')
                  this.$cookie.delete('sw_token')
                  this.$cookie.delete('sw_username')
                  this.$router.replace('home')
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/background.png") no-repeat;
    background-size: 100% 100%;
    /*justify-content: center;*/
  }
  .step {
    width: 55%;
    margin: 25px 0;
  }
  .form {
    width: 55%;
    min-width: 1020px;
    padding: 30px 30px 60px 30px;
    background: url("../../static/img/bg-register.png") no-repeat;
    background-size: 100% 100%;
    color: #492500;
    box-sizing: border-box;
  }
  .form h4 {
    width: 500px;
    margin: 0 auto 20px auto;
    font-size: 15px;
    text-align: left;
    line-height: 25px;
  }
  .form >>> .el-form-item {
    width: 420px;
    margin: 0 auto 22px auto;
  }
  * /deep/ .customInp-small input {
    background: #C8D256;
    border: 1px solid white;
    font-size: 20px;
    color: white;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
  }
  * /deep/ .customInp-small input::-webkit-input-placeholder {
    color: #FFFFFF;
  }
  * /deep/ .customInp-small input::-moz-placeholder {
    color: #FFFFFF;
  }
  * /deep/ .customInp-small input:-ms-input-placeholder {
    color: #FFFFFF;
  }
  .next_btn {
    width: 100px;
    margin: 20px auto;
    cursor: pointer;
    color: white;
    background: #b1be54;
    font-size: 24px;
    font-weight: bold;
    padding: 5px 30px;
    border: 2px solid white;
    border-radius: 20px;
    box-shadow: 0 8px 5px #6F7B08;
    transition: all 0.1s;
  }
  .next_btn:hover {
    transform: scale(1.1)
  }
  * /deep/ .el-input .el-input__clear {
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/modifyPassword.vue